module.exports = __webpack_public_path__ + "static/img/marley-MEnV-HAQCS-edition.e3bf397.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/offer/marley-MEnV-HAQCS-edition.png
// module id = 53
// module chunks = 1 2